module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADESURBVHgBpVKBDcMgDINpB3BCT+AETtgHO2X7YP2AvrILegL9gBOyMAU1hNGV1lKkNsRWIlspAQBwWB4rwIqZegOb+4ITDQ39w6sSIPJMvYj1xLJM3GJNYqNCwNN/4Gv+OG+A8jTIN2c0yUIkZsIVe3d6m7TWS4MEW4r5Hrsx00RtRycu6iSSwEJrWnUASeBN37e9JGa75zbGDhtL21nKQkeQRv7Aowy0oozyA9YApVkj1Q2UeW9hrMhCyJEQ3ygQ0cn5DwyLugiZAcPKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/refresh-icon.png
// module id = 351
// module chunks = 0